var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card"},[_c('TabMenu',{attrs:{"model":_vm.items}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }